/**
 * Loyalty Banner Wallet - Deferred Loading Script
 * Handles the timing of banner appearance based on Yotpo widget state
 */

document.addEventListener('DOMContentLoaded', function() {
  var banner = document.querySelector('.simone-rewards-banner.deferred-loading');
  if (!banner) return;

  // Function to show the banner
  function showBanner() {
    banner.classList.remove('deferred-loading');
    banner.classList.add('deferred-ready');
  }
  // Function to check for Yotpo loyalty content
  function checkYotpoContent() {
    var yotpoWidget = document.querySelector('.yotpo-widget-instance');
    
    if (yotpoWidget) {
      // Yotpo widget instance found, now wait for the actual content
      var yotpoContainer = document.querySelector('.yotpo-loyalty-page-container');
      
      if (yotpoContainer) {
        // Content is ready, show the banner
        showBanner();
        return true;
      } else {
        // Widget exists but content not ready yet, keep checking
        return false;
      }
    } else {
      // No Yotpo widget found, show banner immediately
      showBanner();
      return true;
    }
  }

  // Initial check
  if (!checkYotpoContent()) {
    // If content not ready, use MutationObserver to watch for changes
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          // Check if yotpo-loyalty-page-container was added
          var addedNodes = Array.from(mutation.addedNodes);
          var hasYotpoContent = addedNodes.some(function(node) {
            return node.nodeType === Node.ELEMENT_NODE && 
                   (node.classList.contains('yotpo-loyalty-page-container') ||
                    node.querySelector && node.querySelector('.yotpo-loyalty-page-container'));
          });
          
          if (hasYotpoContent || checkYotpoContent()) {
            observer.disconnect();
          }
        }
      });
    });

    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Fallback timeout in case something goes wrong
    setTimeout(function() {
      observer.disconnect();
      showBanner();
    }, 5000);
  }
});
